export default __webpack_public_path__ + "static/media/customer.9a23ff5d.svg";